import React, { useEffect } from "react";
import { useSwipeable } from "react-swipeable";
import { useNavigate, useLocation } from "react-router-dom";
import "./SwipeWrapper.css"; // Rimuovi se non usi animazioni

export default function SwipeWrapper({ children, redirectTo = "/", onSwipeStart }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove("swipe-out");
    return () => {
      document.body.classList.remove("swipe-out");
    };
  }, []);

  const handlers = useSwipeable({
    onSwipedRight: () => {
      // Chiama il callback prima di iniziare la navigazione
      if (onSwipeStart) {
        onSwipeStart();
      }

      document.body.classList.add("swipe-out");

      setTimeout(() => {
        document.body.classList.remove("swipe-out");

        // Prendi i dati di navigazione da location.state (priorità) o da sessionStorage (fallback)
        const fromPage = location.state?.from || location.state?.fromPage || sessionStorage.getItem("fromPage") || redirectTo;
        const fromScrollY = location.state?.scrollY || sessionStorage.getItem("fromScroll");

        console.log('🔄 SwipeWrapper navigation:', { 
          fromPage, 
          fromScrollY, 
          locationState: location.state,
          sessionStorage: {
            fromPage: sessionStorage.getItem("fromPage"),
            fromScroll: sessionStorage.getItem("fromScroll")
          }
        });

        // Naviga alla pagina di provenienza
        navigate(fromPage, {
          state: {
            shouldRestoreScroll: true,
            scrollY: fromScrollY ? parseInt(fromScrollY, 10) : 0,
            fromSwipe: true // Flag per indicare che arriva da swipe
          }
        });

        // NON pulire il sessionStorage qui - lascia che sia la pagina di destinazione a farlo dopo il ripristino
      }, 300);
    },
    delta: 10,
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: false,
    touchEventOptions: { passive: false },
  });

  return (
    <div {...handlers} className="swipe-wrapper">
      {children}
    </div>
  );
}